<template>
<div class="tab-box">
  <div
    class="tab-item"
    :class="{
      active: index === activeIndex,
      unread: isAdd && readList.indexOf(item.archives_onjob_id) === -1,
      error: checkResult[index] === -1,
    }"
    v-for="(item, index) in infoList"
    :key="index"
    @click="changeTabIndex(index)"
  >
    <span v-if="item.passport_content.surname_cn || item.passport_content.name_cn">{{item.passport_content.surname_cn}}{{item.passport_content.name_cn}}</span>
    <span v-else>未命名</span>
  </div>
</div>
</template>

<script>
export default {
  props: {
    infoList: {
      type: Array,
      default() {
        return [];
      },
    },
    activeIndex: {
      type: Number,
    },
    checkResult: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      readList: [], // 已读列表
      isAdd: this.$route.query.type === 'add',
    };
  },
  created() {
    this.initUnread();
    this.setRead(this.activeIndex);
  },
  methods: {
    changeTabIndex(index) {
      this.$emit('changeIndex', index);
      this.setRead(index);
    },
    // 初始化未读
    initUnread() {
      const readListStr = window.localStorage.getItem('on-job-read-list');
      if (readListStr) {
        const readList = JSON.parse(readListStr);
        this.readList = readList;
      }
    },
    // 设置已读
    setRead(index) {
      if (this.readList.indexOf(this.infoList[index].archives_onjob_id) === -1) {
        this.readList.push(this.infoList[index].archives_onjob_id);
        window.localStorage.setItem('on-job-read-list', JSON.stringify(this.readList));
      }
    },
  },
};
</script>

<style lang="less" scoped>
.tab-box{
  width: 180px;
  flex-shrink: 0;
  padding: 24px 0;
  border-right: 1px solid #DEE2E6;
  .tab-item{
    width: 100%;
    height: 52px;
    padding: 0 24px;
    margin-bottom: 12px;
    position: relative;
    display: flex;
    align-items: center;
    cursor: pointer;
    &:last-child{
      margin-bottom: 0;
    }
    &.active{
      background: rgba(89, 159, 255, 0.06);
      color: #599FFF;
      &::before{
        content: "";
        width: 4px;
        background: #599FFF;
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
      }
    }
    &.unread{
      &::after{
        content: "";
        width: 6px;
        height: 6px;
        background: #F4455C;
        border-radius: 50%;
        margin-left: 3px;
        margin-bottom: 10px;
      }
    }
    &.error{
      &::after{
        content: "";
        width: 14px;
        height: 14px;
        background: url(../../../assets/imgs/on-job/icon-tips-red.png) no-repeat center / 100% 100%;
        border-radius: 0;
        margin-left: 5px;
        margin-bottom: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/on-job/components/edit-on-job-tab.vue